import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_item = _resolveComponent("menu-item")!
  const _component_LinkWindow = _resolveComponent("LinkWindow")!
  const _component_ImageWindow = _resolveComponent("ImageWindow")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (item.type === 'divider')
          ? (_openBlock(), _createElementBlock("div", {
              class: "divider",
              key: `divider${index}`
            }))
          : (_openBlock(), _createBlock(_component_menu_item, {
              key: 1,
              editor: $props.editor,
              icon: item.icon,
              title: item.title,
              action: item.action
            }, null, 8, ["editor", "icon", "title", "action"]))
      ], 64))
    }), 128)),
    _createVNode(_component_LinkWindow, {
      editor: $props.editor,
      isOpen: $data.isLinkWindowOpen,
      onClose: $options.closeLinkWindow
    }, null, 8, ["editor", "isOpen", "onClose"]),
    _createVNode(_component_ImageWindow, {
      editor: $props.editor,
      isOpen: $data.isImageWindowOpen,
      onClose: $options.closeImageWindow
    }, null, 8, ["editor", "isOpen", "onClose"])
  ]))
}